export { TeamPage } from './team'
